export const COPY_LABEL = "Click to copy";
export const COPIED_LABEL = "Done!";

export const COPIED_STATE_DELAY = 0.2;
